import { Snackbar } from "react-native-paper";
import { peacock_blue, toastError, toastSuccess, toastWarning, white, scorpion } from "../../StyleHelpers";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import { useEffect, useRef, useState } from "react";
import { Animated, PanResponder, Dimensions } from "react-native";
import { StyledContainer, StyledFont, StyledText } from "./styled";
import useGenericContentStore from "../../store/genericContent.store";

interface Props {
	type?: ComponentTypeEnum;
	visible: boolean;
	onDismissSnackBar?: any;
	text?: string;
	label?: any;
	duration?: any;
	onPress?: any;
	persist?: boolean;
}

let hideToast: any;

const Toast = ({ visible, onDismissSnackBar, text, label, onPress, type, duration, persist }: Props) => {
	const [toastVisibility, setToastVisibility] = useState(visible);
	const [position, setPosition] = useState("bottom");
	const [range, setRange] = useState(-300);
	const { isNarrow } = useGenericContentStore((state) => ({ isNarrow: state.isNarrow }));

	const hideSnackbar = () => {
		setPosition("right");
		setRange(-2500);

		Animated.timing(animatedValue.current, {
			toValue: 0,
			useNativeDriver: true,
			delay: duration || 5000,
		}).start((result) => {
			if (result.finished) onDismissSnackBar();
		});
	};

	const snackBarStyle = () => {
		if (type === ComponentTypeEnum.Primary) {
			return { backgroundColor: toastSuccess, borderRadius: 16 };
		} else if (type === ComponentTypeEnum.Secondary) {
			return { backgroundColor: toastWarning, borderRadius: 16 };
		} else if (type === ComponentTypeEnum.Tertiary) {
			return { backgroundColor: peacock_blue, borderRadius: 16 };
		} else if (type === ComponentTypeEnum.Processing) {
			return { backgroundColor: scorpion, borderRadius: 16 };
		} else if (type === ComponentTypeEnum.Error) {
			return { backgroundColor: toastError, borderRadius: 16 };
		} else {
			return { backgroundColor: toastError, borderRadius: 16 };
		}
	};

	const [snackbarPosition, setSnackbarPosition] = useState(new Animated.ValueXY());
	const SCREEN_WIDTH = Dimensions.get("window").width;
	const panResponder = useRef(
		PanResponder.create({
			onMoveShouldSetPanResponder: () => true,
			onPanResponderMove: (event, gestureState) => {
				setSnackbarPosition(new Animated.ValueXY({ x: gestureState.dx, y: 0 }));
			},
			onPanResponderRelease: (event, gestureState) => {
				if (gestureState.dx > SCREEN_WIDTH * 0.5) {
					hideSnackbar();
				} else {
					setSnackbarPosition(new Animated.ValueXY({ x: 0, y: 0 }));
					Animated.spring(snackbarPosition, {
						toValue: { x: 0, y: 0 },
						useNativeDriver: true,
					}).start();
				}
			},
		}),
	).current;

	useEffect(() => {
		if (visible) {
			setSnackbarPosition(new Animated.ValueXY({ x: 0, y: 0 }));
			clearTimeout(hideToast);
			setPosition("bottom");
			const showSnackBar = Animated.timing(animatedValue.current, {
				toValue: 1,
				useNativeDriver: true,
			});
			showSnackBar.start((result) => {
				if (result.finished && !persist) hideSnackbar();
			});
		}
		setToastVisibility(visible);
	}, [visible]);

	const animatedValue = useRef(new Animated.Value(0));
	return (
		//@ts-ignores
		<StyledContainer isNarrow={isNarrow}>
			<Animated.View
				style={{
					transform: [{ translateX: snackbarPosition.x }, { translateY: snackbarPosition.y }],
				}}
				{...panResponder.panHandlers}
			>
				<Animated.View
					style={{
						[position]: animatedValue.current.interpolate({ inputRange: [0, 1], outputRange: [range, 0] }),
					}}
				>
					<Snackbar
						wrapperStyle={{ bottom: 0, position: "absolute" }}
						visible={toastVisibility}
						onDismiss={() => {}}
						action={{
							label: label,
							onPress: onPress,
							textColor: white,
							labelStyle: {
								fontSize: isNarrow ? 21 : 25,
								fontWeight: "300",
								height: isNarrow ? "2rem" : "2.5rem",
								justifyContent: "center",
								alignItems: "center",
								display: "flex",
							},
						}}
						style={snackBarStyle()}
					>
						{/* @ts-ignores  */}
						<StyledFont label={label}>
							{/* @ts-ignores */}
							<StyledText isNarrow={isNarrow}>{text}</StyledText>
						</StyledFont>
					</Snackbar>
				</Animated.View>
			</Animated.View>
		</StyledContainer>
	);
};

export default Toast;
